import axios from "axios";
import { GetUserMetadataRequest, GetUserMetadataResponse } from "redmond";
import { config } from "../../config";
import { userMetadataPath } from "../paths";

export const fetchUserMetadata = async (
  body: GetUserMetadataRequest
): Promise<GetUserMetadataResponse> => {
  const res = await axios.post(userMetadataPath, body, {
    baseURL: config.baseURL,
  });

  return res.data;
};

export default fetchUserMetadata;
